<template>
  <div class="card shadow-sm border-0 rounded-custom">
    <div class="table-responsive rounded-table-shell">
      <table class="table align-middle mb-0">
        <thead>
          <tr>
            <th>{{ $t("Date") }}</th>
            <th>{{ $t("Operator") }}</th>
            <th>{{ $t("Material") }}</th>
            <th>{{ $t("Machine") }}</th>
            <th>{{ $t("Elements") }}</th>
            <th>{{ $t("Photo") }}</th>
            <th class="text-end">{{ $t("Actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.uuid">
            <td>{{ formatDate(log.logged_at) }}</td>
            <td>{{ log.user_name || "-" }}</td>
            <td>{{ log.material_name || "-" }}</td>
            <td>{{ log.machine_name || "-" }}</td>
            <td>{{ log.milled_elements_count }}</td>
            <td>
              <button
                v-if="log.photo_url"
                type="button"
                class="btn btn-link p-0 photo-preview-trigger"
                @click="$emit('preview', log)"
              >
                <img
                  :src="log.photo_url"
                  :alt="$t('CAM record photo')"
                  class="rounded border"
                  style="width: 64px; height: 64px; object-fit: cover"
                />
              </button>
              <span v-else>-</span>
            </td>
            <td class="text-end">
              <button
                type="button"
                class="btn icon-circle-button"
                :title="$t('Edit record')"
                :aria-label="$t('Edit record')"
                @click="$emit('edit', log.uuid)"
              >
                <img src="@/assets/icons/edit.svg" alt="" aria-hidden="true" class="icon-circle-image" />
                <span class="visually-hidden">{{ $t("Edit") }}</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="card-body px-4 py-3 border-top d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3"
    >
      <p class="text-muted small mb-0">
        {{ $t("Showing") }} {{ visibleRangeStart }}-{{ visibleRangeEnd }} {{ $t("of") }} {{ totalRecords }}
        {{ $t("records") }}
      </p>

      <div class="d-flex align-items-center gap-2 flex-wrap justify-content-lg-end">
        <button
          class="btn btn-sm btn-outline-secondary rounded-pill"
          :disabled="currentPage <= 1"
          @click="$emit('change-page', currentPage - 1)"
        >
          {{ $t("Previous") }}
        </button>

        <button
          v-for="page in visiblePages"
          :key="page"
          class="btn btn-sm rounded-pill"
          :class="page === currentPage ? 'btn-violet' : 'btn-outline-secondary'"
          @click="$emit('change-page', page)"
        >
          {{ page }}
        </button>

        <button
          class="btn btn-sm btn-outline-secondary rounded-pill"
          :disabled="currentPage >= totalPages"
          @click="$emit('change-page', currentPage + 1)"
        >
          {{ $t("Next") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CamProductionIndexRecordsTable",
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    visibleRangeStart: {
      type: Number,
      default: 0,
    },
    visibleRangeEnd: {
      type: Number,
      default: 0,
    },
    visiblePages: {
      type: Array,
      default: () => [],
    },
    formatDate: {
      type: Function,
      required: true,
    },
  },
  emits: ["preview", "edit", "change-page"],
};
</script>

<style scoped>
.rounded-table-shell {
  border-radius: 1rem;
  overflow: hidden;
}

.photo-preview-trigger {
  line-height: 0;
}

.icon-circle-button {
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-circle-image {
  width: 2.5rem;
  height: 2.5rem;
  display: block;
}

.table thead th {
  background: #f7f4ff;
  border-bottom-width: 1px;
}
</style>
